import { Component } from '@angular/core';
import { MiscellaneousService } from 'src/app/core/services/miscellaneous.service';
import { UtilService } from 'src/app/core/services/util.service';

const SUMMARY_TEMPLATE_TYPE = 'summary';

@Component({
  selector: 'app-pdf-summary',
  templateUrl: './pdf-summary.component.html',
  styleUrls: ['./pdf-summary.component.scss']
})
export class PdfSummaryComponent {

  summaryFiles:any[] = [];
  loading:boolean = false;
  error:string = '';

  constructor(
    public miscellaneousService: MiscellaneousService,
    public util: UtilService
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.miscellaneousService.getTemplateFiles().subscribe({
      next: (res:any) => {
        this.summaryFiles = (res || []).filter((f:any) => f.templateType == SUMMARY_TEMPLATE_TYPE);
        this.loading = false;
      },
      error: () => {
        this.error = 'Unable to load the certification requirements. Please try again later.';
        this.loading = false;
      }
    });
  }

  openFile(item:any) {
    this.miscellaneousService.downloadTemplateFile(item.templateFileId).subscribe({
      next: (res:any) => {
        if (res?.fileContent) {
          const mime = res.contentType || 'application/pdf';
          this.util.blobtoPdf(this.util.b64toBlob(res.fileContent, mime), item.fileName, mime);
        } else {
          this.util.openSnackBar('That document is not available right now. Please try again later.', 'Error');
        }
      },
      error: () => {
        this.util.openSnackBar('Unable to open that document. Please try again later.', 'Error');
      }
    });
  }

}
